import { AddressDetail, EntityEditRequest } from '../interfaces';
import { Feature } from '../helpers/feature';
import { ProjectDefaults } from '../interfaces/project-defaults';

export class EntityModel {
	public address: AddressDetail;
	// Array of brand ids
	public brands: string[];
	public canImportData: boolean;
	public canStartFreeTrial: boolean;
	public canUploadCustomDocuments: boolean;
	public companyCount: number;
	public companyLimit: number;
	public email: string;
	public fiscalMonthStart: number;
	public hasMeasuringToolAccess: boolean;
	public id: string;
	public isActive: boolean;
	public language: string;
	public name: string;
	public operatingCountries: string[];
	public owner: any;
	public countryCode: string;
	public phone: string;
	public projectCount: number;
	public projectLimit: number;
	public projectDefaults: ProjectDefaults;
	public states: string[];
	public stripeId: string;
	public subscriptionLevel: string;
	public suppliers: string[]; // Array of supplier ids
	public supportHours: number;
	public timezone: string;
	public userCount: number;
	public userLimit: number;
	public features: Record<Feature, boolean>;
	public createdAt: Date;

	constructor(json?: any) {
		if (json) {
			Object.assign(this, json);
		}
	}

	/**
	 * Checks if the user's entity has reached is project limit
	 */
	public canCreateMoreProjects(): boolean {
		return this.projectCount < this.projectLimit;
	}

	/**
	 * Checks if the user's entity has reached is user limit
	 */
	public canCreateMoreUsers(): boolean {
		return this.userCount < this.userLimit;
	}

	/**
	 * Checks if the user's entity has reached is company limit
	 */
	public canCreateMoreCompanies(): boolean {
		return this.companyCount > this.companyLimit;
	}

	/**
	 * Creates an update object with fields that entity/edit allows
	 * These fields are also verified on the backend
	 */
	public getUpdateEntityObject(): EntityEditRequest {
		return {
			address: this.address,
			email: this.email,
			name: this.name,
			id: this.id,
			language: this.language,
			countryCode: this.countryCode,
			phone: this.phone,
			states: this.states,
			timezone: this.timezone,
			fiscalMonthStart: this.fiscalMonthStart,
			operatingCountries: this.operatingCountries,
		};
	}
}
